import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getFollowingStrategiesCount} from 'selectors/followingStrategies';

import Aligner from 'components/Aligner';
import TopBar from './components/TopBar';
import {renderSubMenu} from './components/TopBar/helpers';

import './appBar.scss';

const AppBar = ({location, followingStrategiesCount}) => (
  <div className="app-bar">
    <TopBar />
    <div className="nav-bar">
      <Aligner>{renderSubMenu(location, {followingStrategiesCount})}</Aligner>
    </div>
  </div>
);

export default withRouter(
  connect(state => ({
    followingStrategiesCount: getFollowingStrategiesCount(state),
  }))(AppBar),
);
